@let row = this.row();
@let group = this.group();
<div class="requirement-name flex min-w-0 flex-col gap-1">
    <qpx-quippy-pack-requirement-heading
        [smallHeaders]="smallHeaders()"
        [actionId]="actionId()"
        [row]="row"
        [group]="group"
        [rowIndex]="rowIndex()"
        [disabled]="disabled()"
        (changed)="changed.emit()"
        (moved)="moved.emit($event)"
    />
    @if (row.description && !descriptionVisible()) {
        <p
            qpxBody="secondary"
            tone="muted"
            size="sm"
            class="m-0 whitespace-pre-line line-clamp-2"
        >
            {{ row.description }}
        </p>
    }
    @if (!descriptionVisible()) {
        <button
            qpxButton
            size="xs"
            matButton="filled"
            context="secondary"
            class="self-start justify-self-start"
            [disabled]="disabled()"
            [attr.aria-label]="`${row.description ? 'Edit' : 'Add'} description for ${row.name}`"
            [attr.aria-expanded]="false"
            [attr.aria-controls]="`${actionId()}-details-${row.id}`"
            (click)="showDescription()"
        >
            <ng-icon
                qpx
                size="xs"
                [name]="row.description ? 'lucidePencil' : 'lucidePlus'"
                matButtonIcon
            /><span>{{
                row.description ? 'Edit description' : 'Add description'
            }}</span>
        </button>
    }
</div>
@if (descriptionVisible()) {
    <div
        [id]="`${actionId()}-details-${row.id}`"
        class="requirement-details grid min-w-0 gap-3 rounded-[var(--qpx-radius-base)] border border-primary-muted bg-primary-muted p-3 text-primary-muted"
    >
        <div>
            <label mat-label [for]="`${actionId()}-description-${row.id}`"
                >Description</label
            ><mat-form-field
                qpxInput
                class="w-full alt-bg"
                subscriptSizing="dynamic"
            >
                <textarea
                    #descriptionInput
                    matInput
                    rows="2"
                    maxlength="512"
                    [id]="`${actionId()}-description-${row.id}`"
                    [disabled]="disabled()"
                    [ngModel]="row.description"
                    (input)="keepDescriptionVisible()"
                    (ngModelChange)="
                        draft.renameDescription(row.id, $event); changed.emit()
                    "
                ></textarea>
            </mat-form-field>
        </div>
        <button
            qpxButton
            matButton="filled"
            context="primary"
            tone="default"
            size="xs"
            class="justify-self-start"
            [disabled]="disabled()"
            [attr.aria-label]="`Close description for ${row.name}`"
            (click)="hideDescription()"
        >
            <span>Collapse details</span>
        </button>
    </div>
}
<div
    cdkDropList
    [id]="`${actionId()}-documents-${row.id}`"
    [cdkDropListData]="row.id"
    [cdkDropListConnectedTo]="draft.documentListIds(actionId())"
    [cdkDropListDisabled]="disabled()"
    [cdkDropListEnterPredicate]="canDropDocument"
    (cdkDropListDropped)="dropDocument($event)"
    class="document-cell relative m-0 grid min-w-0 gap-1"
    [style.min-height.px]="
        documentDrag.minHeight(`${actionId()}-documents-${row.id}`)
    "
>
    @for (document of row.documents; track document.documentId) {
        <qpx-quippy-pack-document
            [actionId]="actionId()"
            [document]="document"
            [busy]="disabled()"
            [selected]="true"
            [sectionName]="group.name"
            [requirementId]="row.id"
            (changed)="changed.emit()"
            (moved)="moved.emit($event)"
        />
    } @empty {
        <button
            [qpxDropSurface]="
                draft.draggingDocument() && !disabled()
                    ? { state: 'valid', context: 'primary' }
                    : null
            "
            qpxButton
            matButton="outlined"
            size="sm"
            context="secondary"
            tone="muted"
            disabled
            class="no-disabled-color border-dashed!"
        >
            <ng-icon
                qpx
                matButtonIcon
                size="sm"
                name="lucideCircleAlert"
                context="secondary"
            />No documents assigned
        </button>
    }
</div>
